var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tesseramento"}},[_c('tesseramento',{attrs:{"id":"tess_sect"}}),(_vm.ruolo === 'ref')?_c('hr'):_vm._e(),(_vm.ruolo === 'ref')?_c('certificato',{attrs:{"id":"cert_sect"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }